import { Input, Modal } from "antd";
import { useEffect, useRef } from "react";
import AutoFixHighSharpIcon from "@mui/icons-material/AutoFixHighSharp";

const ModifyInvoiceNo = ({
  modifyOpen,
  setModifyOpen,
  handleOk,
  handleCancel,
  modifyCode,
  setModifyCode,
  modifyDetAPI,
  modifyMastAPI,
  modifyOnlineAPI,
  modifyOpeningLedgerAPI,
  handleRest,
  tagNoRef,
}) => {
  const inputRef = useRef(null);

  useEffect(() => {
    if (modifyOpen && inputRef.current) {
      inputRef.current.focus();
    }
  }, [modifyOpen]);
  return (
    <Modal
      className="mi-modal"
      title={<div className="mi-title">MODIFY</div>}
      open={modifyOpen}
      onOk={() => {
        handleRest();
        modifyDetAPI();
        modifyMastAPI();
        modifyOnlineAPI();
        modifyOpeningLedgerAPI();
        tagNoRef.current?.focus();
      }}
      onCancel={handleCancel}
      closable={false}
      okText="OK"
      cancelText="Cancel"
      maskStyle={{
        backdropFilter: "blur(8px)", // <- this applies the blur effect
        backgroundColor: "rgba(0, 0, 0, 0.2)", // optional: tint the background a little
      }}
      afterOpenChange={(open) => {
        if (open && inputRef.current) {
          inputRef.current.focus();
        }
      }}
    >
      {/* ---------- embedded styles (single file) ---------- */}
      <style>{`
        .mi-modal .ant-modal-content{padding:0;border-radius:18px;overflow:hidden}
        .mi-modal .ant-modal-header{margin:0;padding:0;background:transparent}
        .mi-modal .ant-modal-body{padding:14px;background:#eef1f8}
        .mi-modal .ant-modal-footer{margin:0;padding:4px 14px 14px;background:#eef1f8;display:flex;gap:10px}
        .mi-modal .ant-modal-footer .ant-btn{flex:1;height:42px;border-radius:12px;font-weight:800}
        .mi-modal .ant-modal-footer .ant-btn-primary{background:linear-gradient(135deg,#162566,#2a3c8f);border:0}

        .mi-title{background:linear-gradient(135deg,#162566,#2a3c8f);color:#fff;font-weight:800;font-size:16px;text-align:center;padding:14px 12px;letter-spacing:1px}

        .mi-hero{display:flex;align-items:center;gap:12px;background:linear-gradient(135deg,#1f8f6a,#52bd91);color:#fff;border-radius:14px;padding:12px 14px;box-shadow:0 4px 12px rgba(31,143,106,.3)}
        .mi-hero-ico{width:42px;height:42px;border-radius:12px;background:rgba(255,255,255,.22);display:flex;align-items:center;justify-content:center;flex-shrink:0}
        .mi-hero-t{font-weight:800;font-size:14px}
        .mi-hero-s{font-size:12px;font-weight:600;opacity:.92}

        .mi-field{margin-top:12px;background:#fff;border:1.5px solid #e1e6f4;border-radius:14px;padding:8px 12px 10px;box-shadow:0 1px 4px rgba(0,0,0,.05)}
        .mi-label{font-size:11px;font-weight:800;color:#6b76a8;text-transform:uppercase;letter-spacing:.5px;margin-bottom:4px}
        .mi-input{height:46px;border-radius:10px!important;font-size:20px;font-weight:800;color:#162566;letter-spacing:1px}
      `}</style>

      <div className="mi-hero">
        <span className="mi-hero-ico">
          <AutoFixHighSharpIcon />
        </span>
        <div>
          <div className="mi-hero-t">Modify an existing bill</div>
          <div className="mi-hero-s">Enter the invoice number to load it</div>
        </div>
      </div>

      <div className="mi-field">
        <div className="mi-label">Inv No</div>
        <Input
          ref={inputRef}
          placeholder="Enter Inv No"
          className="mi-input"
          inputMode="numeric"
          value={modifyCode}
          onChange={(e) => {
            const value = e.target.value.replace(/\D/g, "");
            if (value.length <= 10) {
              setModifyCode(value);
            }
          }}
        />
      </div>
    </Modal>
  );
};

export default ModifyInvoiceNo;